import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider } from 'antd';
import { Link, Route, Routes, useLocation } from 'react-router-dom';
import { useNavigate } from 'hooks/useNavigate';
import DeleteModal from 'components/deleteModalView';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useAcademyCategories from '../useAcademyCategories';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../hooks/useUser';

const MainPage = () => {
  const { data, columns, filters, loading, onChangeTableFilter, handleDelete } =
    useAcademyCategories();
  const { t } = useTranslation();
  const pages = useRecoilValue(getPage);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <>
      <PageHeader title={t('MODULO RETAIL ACADEMY').toUpperCase()}>
        <Row gutter={16}>
          {pages?.ability?.can_create && (
            <Col>
              <Link to={'new'}>
                <Button big icon={<PlusOutlined />}>
                  {t('NUOVO')}
                </Button>
              </Link>
            </Col>
          )}
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <Divider />
        <Table
          columns={columns}
          dataSource={data.academyCategories}
          pagination={data.pagination}
          loading={loading}
          onChange={onChangeTableFilter}
          onRow={(record) => ({
            onClick: () => {
              if (record?.id) {
                navigate(`${pathname}/${record.id}`);
              }
            },
            style: { cursor: 'pointer' },
          })}
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal onClickDelete={handleDelete} loading={loading} />
          }
        />
      </Routes>
    </>
  );
};

export default MainPage;
